import { createSelector } from 'reselect';

import { type ApplicationState } from '../store';

const getNotificationsStore = (state: ApplicationState) => state.notifications;

export const isAutoOrderEmailEnabled = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.isAutoOrderEmailEnabled,
);

export const isAutoDeliveredEmailEnabled = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.isAutoDeliveredEmailEnabled,
);

export const getOrderShippedEmailSettingSubmitSuccess = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.orderShippedEmailSettingSubmitSuccess,
);

export const getOrderShippedEmailSettingSubmitFailed = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.orderShippedEmailSettingSubmitFailed,
);

export const getOrderArrivedEmailSettingSubmitSuccess = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.orderArrivedEmailSettingSubmitSuccess,
);

export const getOrderArrivedEmailSettingSubmitFailed = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.orderArrivedEmailSettingSubmitFailed,
);

export const getAutoOrderEmailDelayMinutes = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.autoOrderEmailDelayMinutes,
);

export const isLoadingNotificationsSettings = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.isLoadingNotifications,
);

export const getOrderShippedEmailCustomText = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.autoOrderEmailCustomText,
);

export const getOrderArrivedEmailCustomText = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.autoDeliveredEmailCustomText,
);

export const isSampleShippedEmailSending = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.sendingSampleShippedEmail,
);

export const isSampleShippedEmailSent = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.sampleShippedEmailSent,
);

export const isSampleShippedEmailFailed = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.sampleShippedEmailFailed,
);

export const isSampleArrivedEmailSending = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.sendingSampleDeliveredEmail,
);

export const isSampleArrivedEmailSent = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.sampleDeliveredEmailSent,
);

export const isSampleArrivedEmailFailed = createSelector(
  getNotificationsStore,
  (notificationsStore) => notificationsStore.sampleDeliveredEmailFailed,
);
